import {
  CanvasDropdownMenu
} from "./chunk-EWHVUNGQ.js";
import {
  SaveStatusIcon
} from "./chunk-SRZWD5ZB.js";
import {
  DropdownMenu,
  DropdownMenuTrigger
} from "./chunk-IBYHKJKK.js";
import {
  Icon
} from "./chunk-7IEFGXFA.js";
import {
  GenieLogo_default
} from "./chunk-FU2RPPBJ.js";
import {
  cn
} from "./chunk-SBEJSA5Q.js";

// src/WorkspaceTopBar.tsx
import { useEffect, useRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var noDrag = { WebkitAppRegion: "no-drag" };
var control = "flex h-7 w-7 shrink-0 items-center justify-center rounded-md border border-transparent bg-popover text-muted-foreground transition-colors hover:bg-accent hover:text-foreground active:bg-accent/80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring disabled:opacity-40 disabled:pointer-events-none";
function WorkspaceTopBar({ tabs, activeId, onSelect, onClose, onRename, onNew, onHome, actions, menuContent, saveState, nativeWindow, busy, panelControls, modeControl }) {
  const tabList = useRef(null);
  useEffect(() => {
    tabList.current?.querySelector('[aria-selected="true"]')?.scrollIntoView({ block: "nearest", inline: "nearest" });
  }, [activeId, tabs.length]);
  return /* @__PURE__ */ jsxs("header", { "aria-label": "Workspace sessions", className: cn("flex h-9 w-full shrink-0 items-center gap-0.5 border-b border-border bg-background pl-1.5 pr-1 text-foreground select-none", nativeWindow && "pl-24"), style: { WebkitAppRegion: "drag" }, children: [
    /* @__PURE__ */ jsxs(DropdownMenu, { children: [
      /* @__PURE__ */ jsx(DropdownMenuTrigger, { asChild: true, children: /* @__PURE__ */ jsxs("button", { type: "button", "aria-label": "Project menu", title: "Project menu", className: cn(control, "w-10 gap-0.5 data-[state=open]:bg-accent"), style: noDrag, children: [
        /* @__PURE__ */ jsx(GenieLogo_default, { className: "size-3.5 text-foreground" }),
        /* @__PURE__ */ jsx(Icon, { name: "chevron-down", className: "size-2.5" })
      ] }) }),
      /* @__PURE__ */ jsx(CanvasDropdownMenu, { actions, menuContent })
    ] }),
    /* @__PURE__ */ jsx("button", { type: "button", "aria-label": "Home", title: "Home", disabled: busy, onClick: onHome, className: cn(control, activeId === null && "bg-accent text-foreground"), style: noDrag, children: /* @__PURE__ */ jsx(Icon, { name: "house", className: "size-3.5" }) }),
    /* @__PURE__ */ jsx("div", { ref: tabList, role: "tablist", "aria-label": "Open sessions", "aria-orientation": "horizontal", onKeyDown: (event) => {
      if (event.key === " ") event.stopPropagation();
    }, className: "flex h-full min-w-0 items-center gap-0.5 overflow-x-auto overscroll-x-contain [scrollbar-width:none] [&::-webkit-scrollbar]:hidden", style: noDrag, children: tabs.map((tab, index) => {
      const active = activeId === tab.id;
      return /* @__PURE__ */ jsxs("div", { role: "presentation", className: cn("group relative flex h-7 min-w-24 max-w-44 shrink-0 items-center rounded-md border border-transparent transition-colors", active ? "bg-accent text-foreground shadow-sm" : "bg-popover text-muted-foreground hover:bg-accent/80 hover:text-foreground"), children: [
        /* @__PURE__ */ jsx(
          "button",
          {
            type: "button",
            role: "tab",
            "aria-selected": active,
            disabled: busy,
            tabIndex: active || activeId === null && index === 0 ? 0 : -1,
            title: tab.title,
            onClick: () => onSelect(tab.id),
            onDoubleClick: () => onRename?.(tab.id),
            onKeyDown: (event) => {
              let next;
              if (event.key === "ArrowRight") next = (index + 1) % tabs.length;
              if (event.key === "ArrowLeft") next = (index + tabs.length - 1) % tabs.length;
              if (event.key === "Home") next = 0;
              if (event.key === "End") next = tabs.length - 1;
              if (next !== void 0) {
                event.preventDefault();
                event.stopPropagation();
                tabList.current?.querySelectorAll('[role="tab"]')[next]?.focus();
                onSelect(tabs[next].id);
              }
            },
            className: "h-full min-w-0 flex-1 truncate rounded-md pl-2 pr-0.5 text-left text-[11px] active:bg-accent/80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring disabled:opacity-40",
            children: tab.title
          }
        ),
        active && saveState && /* @__PURE__ */ jsx(SaveStatusIcon, { saveState }),
        /* @__PURE__ */ jsx("button", { type: "button", disabled: busy, "aria-label": `Close ${tab.title}`, title: `Close ${tab.title}`, onClick: () => onClose(tab.id), className: cn("mr-1 flex size-5 shrink-0 items-center justify-center rounded transition-colors hover:bg-accent active:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring group-focus-within:opacity-100 group-hover:opacity-100 disabled:opacity-40", active ? "opacity-100" : "opacity-0 focus:opacity-100"), children: /* @__PURE__ */ jsx(Icon, { name: "x", className: "size-2.5" }) })
      ] }, tab.id);
    }) }),
    /* @__PURE__ */ jsx("button", { type: "button", "aria-label": "New session", title: "New session", disabled: busy, onClick: onNew, className: control, style: noDrag, children: /* @__PURE__ */ jsx(Icon, { name: "plus", className: "size-3.5" }) }),
    /* @__PURE__ */ jsx("div", { className: "h-full min-w-6 flex-1" }),
    modeControl && /* @__PURE__ */ jsx("div", { className: "flex h-full shrink-0 items-center px-1.5", style: noDrag, children: modeControl }),
    panelControls && /* @__PURE__ */ jsx("div", { className: "flex h-full shrink-0 items-center border-l border-border px-1", style: noDrag, children: panelControls })
  ] });
}

export {
  WorkspaceTopBar
};
//# sourceMappingURL=chunk-SLHYES3U.js.map